<template>
    <div>
        <v-form ref="saveMapform" v-model="mapSaveFormValid" lazy-validation>

            <v-card>
            <v-toolbar dark color="secondary">
                <v-spacer></v-spacer>
                <v-toolbar-title>{{title}}</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-flex xs12 sm12>
                    <v-text-field 
                        :rules="[rules.required]"
                        v-model="savedMapData.name" 
                        label="Name"
                        hint=""
                        :disabled="!isNew"
                        ></v-text-field>
                </v-flex>
            </v-card-text>
            <v-card-actions class="white hide">
                <v-spacer></v-spacer>
                <v-btn class="primary" @click="save()">
                Save
                </v-btn>
                <v-btn class="info" @click="$emit('onclose')">
                Cancel
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        <!-- {{savedMapData}} -->
            </v-card>
        </v-form>
    </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
    props: ['savedMapData', 'tazTerrXRepsXZips'],
    data () {
        return {
            mapSaveFormValid: true,
            rules: {
                date: v => this.isValidDate(v) || "Not a valid date",
                required: v => !!v || "This field is required"
            },

        }
    },
    computed: {
        // id () {
        //     return this.$route.params.id
        // },
        isNew () {
            return !this.savedMapData.id
        },
        title () {
            return this.isNew?'Add Territory ZIP Assignment' : 'Edit Territory ZIP Assignment'
        }
    },
    methods: {

        ...mapActions('tazApi', [
            'saveSavedMap'
        ]),
        async save() {
            if (this.$refs.saveMapform.validate()) {
                
                var mapId = await this.saveSavedMap(this.savedMapData)
                alert('Map Saved')
                if(this.isNew) {
                    // this.$router.push({ name: 'zips-assign-map-saved', params: { id: mapId } })
                    this.$router.push({ name: 'zips-assign-map-saved-list' })
                } else {
                    this.$emit('onclose')

                }
            }
        },

    },
    watch: {
        // id: async function (newValue) {
        //     this.savedMapData = await this.populateRegionEditModel(newValue)

        // }
    },
    async created () {
        // this.savedMapData = await this.populateRegionEditModel(this.id)
        // this.allActiveReps = await this.searchReps({active:true})
    }
}
</script>
